import { Product } from '@/network/graphql.g'

export const isAvailable = (product: Product): boolean =>
  product?.status && (product?.sizes ?? []).length > 0
